import { Radio as AntdRadio } from 'antd';
import * as T from '../../Typography';
import * as S from './style';
import * as CS from '../style';

const { Group: AntdGroup } = AntdRadio;

const Radio = ({
  selected,
  label,
  error,
  helper,
  handleChange,
  color,
  disabled,
  defaultChecked,
  w,
  options,
  required,
  name,
  horizontal = true,
  value,
  ...props
}) => {
  const decideColor = () => {
    if (error) return 'error';
    return color;
  };

  return (
    <S.Field
      w={w}
      disabled={disabled}
      mb="3"
      color={color}
      error={error}
      {...props}
    >
      {label && (
        <CS.Label htmlFor={label}>
          <T.P color={color} m="0" mb="2" weight="700">
            {required && '*'} {label}
          </T.P>
          {helper && (
            <T.P color={decideColor()} m="0" mb="1" ml="1">
              {helper}
            </T.P>
          )}
        </CS.Label>
      )}
      <AntdGroup
        onChange={val => handleChange(val?.target?.value, name)}
        valued={selected}
        disabled={disabled}
        defaultChecked={defaultChecked}
        style={horizontal ? S.horizontalStyle : {}}
        value={value}
      >
        {options.map(opt => (
          <AntdRadio value={opt.value} style={S.radioStyle} key={opt.value}>
            <T.P m="0" ml="1" color="gray">
              {opt.label}
            </T.P>
          </AntdRadio>
        ))}
      </AntdGroup>
      {error && (
        <T.P color="error" m="0" mt="1">
          {error}
        </T.P>
      )}
    </S.Field>
  );
};

export default Radio;
